// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const deviceReadingId = (z.string());
export const deviceReading = z.object({
    id: deviceReadingId,
    device_id: z.string(),
    metric: z.string(),
    value: z.number(),
    recorded_at: z.date(),
    created_at: z.date(),
});
export const deviceReadingInitializer = z.object({
    id: deviceReadingId.optional(),
    device_id: z.string(),
    metric: z.string(),
    value: z.number(),
    recorded_at: z.date(),
    created_at: z.date().optional(),
});
export const deviceReadingMutator = z.object({
    id: deviceReadingId.optional(),
    device_id: z.string().optional(),
    metric: z.string().optional(),
    value: z.number().optional(),
    recorded_at: z.date().optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=DeviceReading.js.map